// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group.btn:focus,
.btn.focus {
  box-shadow: none !important;
}

.group.btn:focus:not(.active),
.btn.focus:not(.active) {
  background-color: #fff !important;
  color: var(--bs-btn-color);
}

.large-calendar {
  width: 97%;
}

.event-box {
  display: flex;
}

.event-status-color {
  width: 10px;
  height: auto;
  border-radius: 2px;
  margin-right: 5px;
}

.rbc-event {
  padding: 0;
}

.event-inside-comp {
  padding: 2px 5px;
}
`, "",{"version":3,"sources":["webpack://./frontend_admin/components/calendar.css"],"names":[],"mappings":"AAAA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".group.btn:focus,\n.btn.focus {\n  box-shadow: none !important;\n}\n\n.group.btn:focus:not(.active),\n.btn.focus:not(.active) {\n  background-color: #fff !important;\n  color: var(--bs-btn-color);\n}\n\n.large-calendar {\n  width: 97%;\n}\n\n.event-box {\n  display: flex;\n}\n\n.event-status-color {\n  width: 10px;\n  height: auto;\n  border-radius: 2px;\n  margin-right: 5px;\n}\n\n.rbc-event {\n  padding: 0;\n}\n\n.event-inside-comp {\n  padding: 2px 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
